import { WaitMoveGetId, GetGoodsDetail } from "./api";
import { message } from "ant-design-vue";
import { CheckValidation } from "@/utils/co_util";
import { COU_getRemoveRepeatData } from "@/utils/co_utils";
import imgUtil from "@/views/moving_function/utils/img";
import { GetItemType } from "@/utils/constant/item";
import newSkuUtil from "@/views/moving_function/utils/sku";

// 显示淘特授权弹出框
function ShowTaoteAuthModal(This, obj) {
  if (obj?.Code && obj.QrCodeUrl) {
    This.$refs.authTaoteModal.params = obj;
    This.$refs.authTaoteModal.visible = true;
  }
  This.loading = false;
  This.$refs.logModal?.addLog("已停止获取商品数据 ....");
}
// 显示1688授权提示
function ShowAliAuthModal(link, msg) {
  return CheckValidation(
    link,
    msg ? msg + "。" : "铺货1688商品，需要先授权订购1688应用【晓风分销】，以免出无货源违规！",
    "如已确认操作完成，请点击【确定】按钮",
    `去${msg?.includes("免费") ? "前往订购付费版" : "授权"}`,
    {
      class: msg ? "" : "global-ali-auth-modal",
      cancelText: msg?.includes("免费") ? "查看1688店铺授权" : "取消",
      cancelFn: () =>
        window.open(
          "https://ufuwu.1688.com/page/fuwu_work_isv_container.htm?appkey=6887888&spm=a26370.20994420.fwsj_work_bench.17.b96961ceWKWBJN"
        ),
    }
  );
}
// 显示1688授权提示
// function ShowAliAuthModal(link, msg) {
//   return CheckValidation(link, msg, "如已确认操作完成，请点击【确定】按钮", "去授权", {
//     class: msg ? "" : "global-ali-auth-modal",
//   });
// }

// 检查获取商品详情是否已经全部完成
function checkIsAllFinish(This, list, finalCount) {
  if (finalCount === list.length) {
    const previewData = This.$refs.shippingPreviewList;
    This.loading = false;
    clearInterval(This.timer);
    This.$refs.logModal.addLog(
      `已经执行完毕，共获取【${list.length}】个商品数据，成功【${previewData.list.length}】个，失败【${
        list.length - previewData.list.length
      }】个${previewData.list.length ? "，可点击【打开铺货预览列表】按钮，展示商品数据。" : "。"}`
    );
    // 如果有一个商品详情获取了,那么铺货预览是默认选择第一个商品,并添加键盘事件
    if (previewData.list?.length && !previewData.currentCheckedItem?.id) {
      previewData.currentCheckedItem = { ...This.$refs.shippingPreviewList.list[0] };
      previewData.addEvent();
    }
  }
}

// 整理接口返回的商品详情数据
async function getFormatGoodsData({ item }) {
  console.log("返回的 ......", JSON.parse(JSON.stringify(item)));
  let obj = {};
  try {
    obj = {
      id: item.ItemId,
      logId: item.logId,
      title: item.Title,
      oldTitle: item.Title,
      category: null,
      categoryName: "",
      platformType: item.PlatformType,
      platformTypeStr: GetItemType(item.PlatformType).name,
      mainImages: item.MainPicList || [],
      detailImages: item.DescPicList || [],
      categoryProperty: { important: [], other: [] },
      brandId: item.BrandId,
      brandName: item.BrandName,
      goodsUrl: item.url,
      skuList: [],
      skuInfo: [],
      canSelectPropertyList: [],
      OriginCatIds: item.OriginCatIds,
      OriginCatNames: item.OriginCatNames,
    };
    await newSkuUtil.SetGoodsSkuInfo({ item, obj });
    if (item.CatIds?.length) {
      obj.category = item.CatIds.join();
      obj.categoryName = item.CatNames?.join(",")?.replaceAll(",", ">");
    }
    if (!obj.mainImages.length && obj.detailImages.length) obj.mainImages = obj.detailImages.slice(0, 5);
    else if (obj.mainImages.length < 3 && obj.detailImages.length) {
      // 如果主图小于3张并且有详情图的情况下
      for (let i = obj.mainImages.length; i < 5; i++) {
        if (obj.detailImages[i - 1]) obj.mainImages[i] = obj.detailImages[i - 1];
      }
    }
    if (obj.mainImages.length) {
      obj.mainImages = obj.mainImages.slice(0, 5);
      obj.mainImages = await imgUtil.GetFinalImageList(obj.mainImages, "1:1");
    }
    if (obj.detailImages.length) {
      obj.detailImages = obj.detailImages.slice(0, 50).filter((op) => !op.includes(".gif"));
      // 详情图片不限制, 那就没有必须去获取每张详情图的宽高
      const arr = [];
      for (let img of obj.detailImages) {
        arr.push({ width: 500, height: 500, img });
      }
      obj.detailImages = arr;
    }
  } catch (error) {
    console.log(error);
  }
  console.log("整理后.......", obj);
  return obj;
}

// 铺货预览前根据商品id去重
function checkGoods(This, obj) {
  This.loading = true;
  const list = COU_getRemoveRepeatData(obj.list, obj.key || "id");
  if (!list.length) {
    This.loading = false;
    message.warning("暂无合适的商品，请重试");
    return;
  }
  return list;
}

// 铺货预览前的固定操作
function beforeMoveOperate(This, list, isNotClearLog) {
  clearInterval(This.timer);
  This.$refs.shippingPreviewList.clearShippingList();
  if (!isNotClearLog) This.$refs.logModal.clear();
  This.$refs.logModal.addLog(
    ` 正在获取【${list.length}】个商品数据中${list.length > 1 ? " (会过滤相同的商品)" : ""}，请耐心等待 ...`
  );
}

// 点击【铺货预览】时执行 , 选品中心, 链接铺货, 以图搜款, 发布同款, 上货列表, 爆单计划
async function MovePreview(This, obj, isNotClearLog) {
  const list = checkGoods(This, obj);
  if (!list) return;
  // 如果有传key, 说明是在上货列表里执行
  if (!obj?.key) {
    const home = This.$refs.home;
    if (home) home.text = "";
  }
  This.isShowLogModal = true;
  getGoodsData(This, { list, templateId: obj.goodsTemplateId, isNotClearLog });
}

// 获取铺货预览的商品列表数据
function getGoodsData(This, { list, templateId, isNotClearLog }) {
  This.$nextTick(async () => {
    beforeMoveOperate(This, list, isNotClearLog);
    let finalCount = 0;
    for (let i = 0; i < list.length; i++) {
      // 如果发现弹出框关闭了,则终止操作
      if (!This.isShowLogModal) break;
      const item = list[i];
      let goodsId = item.OutGoodsId;
      // 有templateId时说明不是在上货列表里获取商品数据, 需要先添加铺货记录
      if (templateId) {
        var { success, msg, result } = await WaitMoveGetId({ url: item.link, templateId });
        goodsId = item.id;
      }
      let str = ` 商品ID：【${goodsId}】，获取数据`;
      if (success || !templateId) {
        const list2 = [];
        pushGoodsData({
          list: list2,
          item: result || item,
          str,
        }).then((str) => {
          finalCount++;
          This.$refs.shippingPreviewList.setShippingList(list2);
          This.$refs.logModal.addLog(str + `，${finalCount} / ${list.length}`);
          This.$refs.shippingPreviewList.addEvent();
        });
      } else {
        // 1688
        if (item.link?.includes("detail.1688") && result?.ClickUrl) {
          //   await ShowAliAuthModal(result.ClickUrl, msg);
          await This.$refs.MallLimitationModal.open({ msg: msg });
          i--;
          continue;
        }
        finalCount++;
        str += `【失败】，原因:【${msg}】，${finalCount} / ${list.length}`;
        This.$refs.logModal.addLog(str);
      }
    }
    This.timer = setInterval(() => checkIsAllFinish(This, list, finalCount), 200);
  });
}

// 获取商品详情, 并格式化数据
async function pushGoodsData({ list, item, str }) {
  const logId = item.Id;
  const { result, msg } = await GetGoodsDetail(logId);
  if (result.ItemId) {
    str += "【成功】";
    result.logId = logId;
    result.platformTypeStr = item.type_str;
    result.url = item.Url;
    const data = await getFormatGoodsData({ item: result });
    list.push(data);
  } else str += `【失败】，原因:【${msg}】`;
  return str;
}

export default {
  MovePreview,
  ShowTaoteAuthModal,
  ShowAliAuthModal,
};
